import { ActivityStatus, type KubernetesObjectStatus, type KubernetesStepStatus, type KubernetesTaskResourceStatusResource } from "@octopusdeploy/octopus-server-client";
import { useMemo, useState } from "react";
import type { KubernetesDetailsBaseProps, KubernetesDetailsFilter } from "~/areas/tasks/components/Task/Kubernetes/KubernetesDetailsLayout";
import { KubernetesObjectDrawer } from "~/areas/tasks/components/Task/Kubernetes/KubernetesObjectDrawer";
import { KubernetesSnapshotStepExpander } from "~/areas/tasks/components/Task/Kubernetes/Snapshot/KubernetesSnapshotStepExpander";
import { getStepActivity } from "~/areas/tasks/components/Task/Kubernetes/getStepActivity";
type KubernetesSnapshotStepsLayoutProps = KubernetesDetailsBaseProps & {
    filter: KubernetesDetailsFilter;
    resourceStatusResult: KubernetesTaskResourceStatusResource | undefined;
    onDrawerOpen: (object: KubernetesObjectStatus) => void;
};
export const KubernetesSnapshotStepsLayout = (props: KubernetesSnapshotStepsLayoutProps) => {
    const [objectStatusInDrawer, setObjectStatusInDrawer] = useState<KubernetesObjectStatus | undefined>(undefined);
    const openDrawerWithObject = (object: KubernetesObjectStatus) => {
        props.onDrawerOpen(object);
        setObjectStatusInDrawer(object);
    };
    const stepStatusMap = useMemo(() => {
        const lookup: Record<string, KubernetesStepStatus | undefined> = {};
        for (const step of props.steps) {
            lookup[step.stepName] = (props.resourceStatusResult?.KubernetesStepsStatus || []).find((v) => v.StepName === step.stepName);
        }
        return lookup;
    }, [props.resourceStatusResult, props.steps]);
    return (<>
            {props.steps.map(({ stepName, actionId, isResourceStatusEnabled, isAtomicHelmStep }) => {
            const activity = getStepActivity(stepName, props.activityLogs) ?? { Name: stepName, Started: "", Ended: "", Status: ActivityStatus.Pending };
            return (<KubernetesSnapshotStepExpander key={actionId} stepName={stepName} stepActivity={activity} stepResourceStatus={stepStatusMap[stepName]} isAtomicHelmStep={isAtomicHelmStep} isResourceStatusEnabled={isResourceStatusEnabled} showObjectDrawer={openDrawerWithObject} {...props}/>);
        })}
            <KubernetesObjectDrawer onClose={() => setObjectStatusInDrawer(undefined)} objectStatus={objectStatusInDrawer}/>
        </>);
};
